<template>
  <!-- 手機版樣式 -->
  <div class="mobileTable">
    <div class="mt">
      <div><p :style="{ fontSize: fontSize.p + 'em' }">投稿主題</p></div>
      <div>
        <p :style="{ fontSize: fontSize.p + 'em' }">{{ data.pageTitle }}</p>
      </div>
    </div>

    <div class="mt">
      <div><p :style="{ fontSize: fontSize.p + 'em' }">內容</p></div>
      <div style="padding: 10px">
        <div class="ellipsis" v-html="data.pageContent">
        </div>
      </div>
    </div>
    <div class="mt">
      <div><p :style="{ fontSize: fontSize.p + 'em' }">投稿者</p></div>
      <div>
        <p :style="{ fontSize: fontSize.p + 'em' }">{{ data.posterName }}</p>
        <!-- <p :style="{ fontSize: fontSize.p + 'em' }">{{ data.pagePublishUp }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from 'vue'
export default {
  name: "ContributionRWD",
  props: {
    data: {
      type: Object,
      default() {
        //投稿主題 - 內容 - 發布時間
        return {
          pageId: 0,
          pageContent: "",
          posterName: "",
          pagePublishUp: "",
          pageTitle: "",
        };
      },
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject('fontSize');
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.mobileTable {
  display: none;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
  width: 100% !important;
}
@include lg {
  .mobileTable {
    display: block;
    border: 1px solid $main_color;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 50px;

    .mt > div:nth-child(1) {
      background-color: $main_color;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 25%;
      p{
        padding: 10px;
      }
    }
    .mt > div:nth-child(2){
      p{
        padding: 10px;
      }
    }
    .mt > div > a {
      padding: 10px 15px;
    }
    .mt {
      display: flex;
      div {
        width: 75%;
      }
    }
    .mt:nth-child(1),
    .mt:nth-child(2) {
      border-bottom: rgb(211, 211, 211) 1px solid;
    }
  }
}
</style>
